module.exports = __webpack_public_path__ + "img/department-info-nothing.4a3c6fa0.png";